import axios from "axios";
import * as apiPath from "./apiPath";
import * as header from "./apiHeaders";
import {
  ticketingPathBaseUrl,
  orderManagementUrl,
} from "../config/appProperties";

export const changePassword = async (body) => {
  let options = header.getAuthJSONHeader();
  const res = await axios.post(
    `${process.env.REACT_APP_AUTH_URL}${apiPath.changePassword}`,
    body,
    options
  );
  return res;
};

export const getAllTransactions = async () => {
  let options = header.getAuthJSONHeaderwithFBPixel();
  const res = await axios.get(
    `${ticketingPathBaseUrl}${apiPath.allTransactionsURL}`,
    options
  );
  return res;
};

export const getCharityTransactions = async () => {
  const options = header.getAuthJSONHeaderwithFBPixel();
  const res = await axios.get(
    `${ticketingPathBaseUrl}${apiPath.charityTransactionsURL}`,
    options
  );
  return res;
};

export const downloadInvoice = async (orderId, transactionId) => {
  let options = header.getAuthJSONHeader();
  const res = await axios.get(
    `${ticketingPathBaseUrl}${apiPath.downloadInvoice}` +
      "?orderId=" +
      orderId +
      "&transationId=" +
      transactionId,
    options
  );
  return res;
};

export const downloadGroupCodes = async (id) => {
  let options = header.getAuthJSONHeaderwithFBPixel();
  const res = await axios.get(
    `${ticketingPathBaseUrl}${apiPath.downloadGroupCodes}` +
      "/" +
      id +
      "/codes",
    options
  );
  return res;
};

export const getcharityDtls = async (id) => {
  let options = header.getAuthJSONHeaderwithFBPixel();
  const res = await axios.get(
    `${ticketingPathBaseUrl}${apiPath.getCharityDtls}` + "?transactionId=" + id,
    options
  );
  return res;
};

export const getReferralCodev2 = async (body) => {
  try {
    let options = header.getAuthJSONHeader();
    const res = await axios.post(
      `${orderManagementUrl}${apiPath.getReferralCode}`,
      body,
      options
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getReferralLinks = async (eventMasterId) => {
  try {
    let body = { eventId: eventMasterId };
    let options = header.getAuthJSONHeader();
    const res = await axios.post(
      `${orderManagementUrl}${apiPath.getReferalLinks}`,
      body,
      options
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getReferralUsages = async (body) => {
  try {
    let options = header.getAuthJSONHeader();
    const res = await axios.post(
      `${orderManagementUrl}${apiPath.getReferralUsages}`,
      body,
      options
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getReferralEventList = async () => {
  let options = header.getAuthJSONHeader();
  const res = await axios.get(
    `${orderManagementUrl}${apiPath.getReferralEventList}`,
    options
  );
  return res;
};

export const getRunsForList = async () => {
  let options = header.getWithOutAuthJSONHeader();
  const res = await axios.get(
    `${process.env.REACT_APP_ACTIVITY_URL}${apiPath.getRunsForList}`,
    options
  );
  return res;
};

export const logoutFromAllDevices = async () => {
  let options = header.getAuthJSONHeader();
  console.log(options);
  const res = await axios.post(
    `${process.env.REACT_APP_AUTH_URL}${apiPath.logout}`,
    null,
    options
  );
  return res;
};
